export default [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/dashboard/dashboard/index.vue"),
  },
];
